// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2tV70","header":"ReportDetails_header__2GkeT","title":"ReportDetails_title__1rSpW","left":"ReportDetails_left__3N0Xb"};